import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BrainIcon, ShieldAlertIcon, BatteryWarningIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-sage-light/30" data-id="element-126">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <FadeIn data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-129">
            Después de los 35 años, el juego cambia
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-130">
          <p className="text-lg md:text-xl text-center text-brown/80 mb-16 max-w-3xl mx-auto" data-id="element-131">
            Tu cuerpo ya no responde a las dietas de choque. Si tienes un
            trabajo exigente, hijos que cuidar o noches de insomnio, tu cuerpo
            vive en <strong data-id="element-132">"Modo Supervivencia"</strong>.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-133">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-sage/30 z-0" data-id="element-134" />

          <FadeIn delay={0.2} className="relative z-10 bg-white p-8 rounded-2xl shadow-sm border border-sage-light text-center" data-id="element-135">
            <div className="w-16 h-16 mx-auto bg-sage-light rounded-full flex items-center justify-center mb-6 text-sage" data-id="element-136">
              <BrainIcon size={32} data-id="element-137" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-138">El Cerebro en Alerta</h3>
            <p className="text-brown/70" data-id="element-139">
              Cuando estás estresada, tu cerebro libera Cortisol constantemente,
              creyendo que estás en peligro.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="relative z-10 bg-white p-8 rounded-2xl shadow-sm border border-sage-light text-center" data-id="element-140">
            <div className="w-16 h-16 mx-auto bg-sage-light rounded-full flex items-center justify-center mb-6 text-sage" data-id="element-141">
              <ShieldAlertIcon size={32} data-id="element-142" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-143">Protección de Órganos</h3>
            <p className="text-brown/70" data-id="element-144">
              Esta hormona le ordena a tu cuerpo guardar grasa en el abdomen
              para proteger tus órganos vitales.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} className="relative z-10 bg-white p-8 rounded-2xl shadow-sm border border-sage-light text-center" data-id="element-145">
            <div className="w-16 h-16 mx-auto bg-sage-light rounded-full flex items-center justify-center mb-6 text-sage" data-id="element-146">
              <BatteryWarningIcon size={32} data-id="element-147" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-148">Energía Agotada</h3>
            <p className="text-brown/70" data-id="element-149">
              Descompone tus músculos para obtener energía rápida, dejándote
              flácida y exhausta.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} className="mt-16 text-center" data-id="element-150">
          <p className="text-xl font-serif italic text-brown/90 bg-white inline-block px-8 py-4 rounded-full shadow-sm" data-id="element-151">
            El resultado es frustrante: vientre abultado, brazos flácidos y un
            cansancio que no se quita ni con tres cafés.
          </p>
        </FadeIn>
      </div>
    </section>;
}